<template>
    <div class="main-content">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h1 class="title mb-3">Projects</h1>
                    <div class="team-member-part">
                        <div class="team-member-btn">
                            <div class="delete-link">
                                <a href="javascript:;" @click="deletePrompt()">
                                    <svg width="18" height="22" xmlns="http://www.w3.org/2000/svg"><defs><filter id="a"><feColorMatrix in="SourceGraphic" values="0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"/></filter></defs><g transform="translate(-3 -.5)" filter="url(#a)" fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/><path d="M19 7.25c.46 0 .811.41.741.864l-1.739 11.304a2.75 2.75 0 01-2.718 2.332H8.716a2.75 2.75 0 01-2.718-2.332L4.258 8.114A.75.75 0 015 7.25h14zM8.737 8.75H5.874L7.48 19.19a1.25 1.25 0 001.236 1.06h.544l-.523-11.5zm5.023 0h-3.521l.523 11.5h2.475l.523-11.5zm4.366 0h-2.864l-.523 11.5h.545a1.25 1.25 0 001.236-1.06l1.606-10.44zm-2.379-7.455a1 1 0 01.994.883l.006.117V4.75h3.003a.75.75 0 01.102 1.493l-.102.007H3.978a.75.75 0 01-.102-1.493l.102-.007h3.337V2.295a1 1 0 01.883-.993l.117-.007h7.432zM15.25 2.75h-6.5v2h6.5v-2z" fill="#6E7077" fill-rule="nonzero"/></g></svg>
                                </a>
                            </div>
                            <a href="javascript:;" class="btn btn-primary" @click="$router.push({ name: 'Create Project' })">
                                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12"><path fill="#fff" d="M6.099 0c.44 0 .796.336.796.75V5h4.514c.44 0 .796.336.796.75s-.356.75-.796.75H6.895v4.25c0 .414-.356.75-.796.75-.44 0-.797-.336-.797-.75V6.5H.79c-.44 0-.797-.336-.797-.75S.35 5 .79 5h4.513V.75c0-.414.357-.75.797-.75z"/></svg>
                                new project
                            </a>

                        </div>
                        <div class="team-member-search">
                            <div class="custom-control custom-checkbox" v-cloak>
                                <input type="checkbox" class="custom-control-input" @click="toggleAll($event)" id="all" :indeterminate.prop="bulk_select.length && bulk_select.length < originalProjects.length" :checked="bulk_select.length && bulk_select.length == projects_count">
                                <label class="custom-control-label" for="all"></label>
                            </div>
                            <div class="team-search">
                                <a class="close-btn" v-if="search" @click="search = ''; filteredProjects();"></a>
                                <input type="text" v-model="search" placeholder="Search projects…" @keyup.enter="filteredProjects();" @keyup.esc="search = ''; filteredProjects();">
                                <button @click="filteredProjects();" :disabled="!search"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><g><g><path fill="#6E7077" d="M14.108 7.054a7.054 7.054 0 1 0-2.609 5.477l5.255 5.255a.73.73 0 0 0 1.032-1.032L12.531 11.5a7.025 7.025 0 0 0 1.577-4.445zm-12.649 0a5.595 5.595 0 1 1 11.19 0 5.595 5.595 0 0 1-11.19 0z"/></g></g></svg></button>
                            </div>
                        </div>
                        <div class="team-member-list" v-if="projects.length" v-for="project in projects" :key="project.id">
                            <div class="custom-control custom-checkbox" v-if="project.mine">
                                <input type="checkbox" class="custom-control-input" :id="'customCheck' + project.id"
                                       v-on:change="selectProject($event, project.id)"
                                       :checked="project.checked">
                                <label class="custom-control-label" :for="'customCheck' + project.id"></label>
                            </div>
                            <div class="project-name">
                                <p><router-link :to="{ name: 'Project View', params: { id: project.id }}">{{ project.name }}</router-link></p>
                            </div>
                            <div class="project-documents">
                                <p>Documents {{ project.documents_count }}</p>
                            </div>
                            <div class="project-date">
                                <p>Modified {{  timeSince(project.updated_at) }}</p>
                            </div>
                            <div class="project-owner" v-if="project.team_id">
                                <p>{{  project.author }}</p>
                            </div>
                            <div class="project-sharing" v-if="project.team_id">
                                <div class="documents-shared-right">
                                    <div class="team-switch" v-if="project.mine">
                                        <span class="btn shared-btn">TEAM</span>
                                        <div class="custom-control custom-switch">
                                            <input type="checkbox" class="custom-control-input"
                                                   @click="teamShareProject($event, project)"
                                                   :checked="project.team_shared"
                                                   :id="'team-shared' + project.id">
                                            <label class="custom-control-label" :for="'team-shared' + project.id"></label>
                                        </div>
                                    </div>
                                    <div class="team-switch" v-else>
                                        <span class="btn shared-btn">TEAM</span>
                                    </div>
                                </div>
                            </div>
                            <div class="team-member-role"
                                 @focusout="hideOption($event);"
                                 tabindex="1">
                                <span style="text-transform: capitalize;">{{ project.team_role }}</span>
                                <div class="team-member-more" v-if="project.mine">
                                    <a href="javascript:;" @click="activeOption = project.id" class="team-more-link pointer"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="4" viewBox="0 0 16 4"><g><g><path fill="#000" d="M6.5 2.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0zm6 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0zm-12 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0z"/></g></g></svg></a>
                                    <div class="team-more-dropdown" v-if="project.id == activeOption" style="display: block;"
                                         ref="memberOption">
                                        <ul>
                                            <li><a href="javascript:;" @click="deleteConfirm = true; selectedProject  = project" class="red-txt">Delete</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

        </div>
        <v-dialog />
        <ProjectConfirm v-if="deleteConfirm"/>
        <ProjectBulkDeleteConfirm v-if="deleteBulkConfirm"/>
    </div>
</template>

<script>
import vmodal from 'vue-js-modal'
import ApiService from "../../api/api.service";
import ProjectConfirm from "./ProjectConfirm";
import ProjectBulkDeleteConfirm from "./ProjectBulkDeleteConfirm";

export default {
    name: "ProjectManagement",
    components: {
        vmodal,
        ProjectConfirm,
        ProjectBulkDeleteConfirm
    },
    data() {
        return {
            bulk_select: [],
            search: '',
            projects: [],

            originalProjects: [],
            activeOption: null,
            projects_count: 0,

            deleteConfirm: false,
            deleteBulkConfirm: false,
            selectedProject: null,

            filterType: '',
        }
    },
    mounted() {
        this.getProjects();
    },
    methods: {
        getProjects() {
            ApiService.setHeader();
            ApiService.get('/api/projects')
                .then(({data}) => {
                    this.projects = data.projects;

                    this.originalProjects = JSON.parse(JSON.stringify(data.projects));
                    this.projects_count = this.originalProjects.length;
                })
                .catch((response) => {
                    console.log(response);
                });
        },

        remove() {
            ApiService.setHeader();
            ApiService.delete('/api/projects/' + this.selectedProject.id)
                .then(({data}) => {
                    if(data) {
                        this.projects = this.projects.filter((p) => p.id !== this.selectedProject.id);
                    }
                    this.$parent.selectedProject = null;

                    // window.history.replaceState(null, null, "?ups=123");

                })
                .catch();
        },
        toggleOption() {},
        toggleAll(e) {

            this.projects_count = 0;
            this.bulk_select = []

            if(e.target.checked) {
                this.projects.forEach((p) => {
                    if(p.team_id && ! p.mine) {
                        return;
                    }
                    this.projects_count = this.projects_count + 1;
                    this.bulk_select.push(p.id);
                    p.checked = true;
                })
            } else {
                this.projects.forEach((p) => {
                    p.checked = false;
                })
            }
        },
        selectProject(e, id) {
            if(e.target.checked) {
                this.bulk_select.push(id);
            } else {
                let index = this.bulk_select.indexOf(id);
                if(index !== -1) {
                    this.bulk_select.splice(index, 1);
                }
            }

            this.projects_count = this.bulk_select.length;
        },
        hideOption(e) {
            if (!e.currentTarget.contains(e.relatedTarget)) {
                this.activeOption = null;
                this.activeChangeRoleId = null;
            }
        },
        bulkRemove() {
            ApiService.setHeader();
            ApiService.post('/api/projects/bulk-delete', { ids : this.bulk_select })
                .then(({data}) => {
                    if(data) {
                        this.projects = this.projects.filter((m) => this.bulk_select.indexOf(m.id) === -1);
                        this.bulk_select = [];
                    }

                    window.update_projects = true;

                    this.$modal.hide('dialog');
                })
                .catch();
        },
        deletePrompt()
        {
            if(this.bulk_select.length) {
                this.deleteBulkConfirm = true;
            } else {
                this.$modal.show('dialog', {
                    title: '&nbsp;',
                    text: '<p class="text-center">Please select a project to delete.</p>',
                    buttons: [
                        {
                            title: 'Okay',
                            handler: () => {
                                this.$modal.hide('dialog')
                            }
                        }
                    ]
                })
            }
        },

        filteredProjects() {
            const search = this.search.toLowerCase().trim();

            if(search) {
                this.projects = this.originalProjects.filter(
                    project => project.name.toLowerCase().indexOf(search) > -1
                );
            } else {
                this.projects = JSON.parse(JSON.stringify(this.originalProjects));
            }
        },

        timeSince(stringDate) {
            let date = new Date(stringDate).getTime();
            let seconds = Math.floor((new Date() - date) / 1000);

            let interval = seconds / 31536000;

            if (interval > 1) {
                return Math.floor(interval) + " years ago";
            }
            interval = seconds / 2592000;
            if (interval > 1) {
                return Math.floor(interval) + " months ago";
            }
            interval = seconds / 86400;
            if (interval > 1) {
                return Math.floor(interval) + " days ago";
            }
            interval = seconds / 3600;
            if (interval > 1) {
                return Math.floor(interval) + " hours ago";
            }
            interval = seconds / 60;
            if (interval > 1) {
                return Math.floor(interval) + " minutes ago";
            }
            return Math.floor(seconds) + " seconds ago";
        },


        teamShareProject($event, project) {
            ApiService.setHeader();
            ApiService.put('/api/projects/share/' + project.id, { team_shared: $event.target.checked})
                .then(({data}) => {
                    this.documentData.team_shared = $event.target.checked;
                })
                .catch((res) => {
                    console.log(res)
                });
        }

    }
}
</script>

<style scoped>
.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after {
    top: 7px;
    left: 7px;
}
.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {
    color: #fff;
    border-color: #23a6cd;
    background-color: #23a6cd !important;
}

.project-name p a {
    color: #1E73BD;
}
.project-name p a:hover {
    text-decoration: underline;
}
.team-member-more .role-change{
    color: #000;
    font-size: 14px;
    position: absolute;
    right: 160px;
    top: 0px;
    box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.2);
    width: 100px;
    z-index: 2;
    background: #fff;
    border-radius: 6px;
    font-weight: 400;
    opacity: 1;
    transition: all 0.3s ease;
}
.team-more-dropdown ul li a {
    padding: 7px 27px;
}
.team-search input {
    font-family: "Poppins", sans-serif;
    font-size: 16px;
    font-weight: 400;
}
.team-search a.close-btn {
    background: url(/assets/img/cross.svg) no-repeat scroll 10px 15px;
    background-size: 12px;
    padding-left: 30px;
    width: 50px;
    height: 100%;
    position: absolute;
    top: -3px;
    left: 15px;
    border: 0;
    border-radius: 0;
    transition: inherit;
    cursor: pointer;
}


a.btn-primary {
    border-radius: 20px;
}

.team-member-btn a:hover svg path{
    fill: #1e73bd;
}
.team-member-btn .delete-link a:hover svg path:first-child {
    fill: none;
}
h1.title svg {
    width: 20px;
}
h1.title span.team-name {
    color: #1e73bd;
}
a.blue-hover:hover {
    color: #23a6cd;
}

.team-member-list p {
    padding: 5px;
    margin: 0px;
}
.team-member-list .project-name {
    width: 20%;
}
.team-member-list .project-documents {
    width: 20%;
}
.team-member-list .project-date {
    width: 20%;
}
.team-member-list .project-author {
    width: 20%;
}
.team-member-list .project-sharing {
    width: 10%;
}
.documents-shared-right {
    margin-top: auto;
}

.documents-shared-right .custom-switch {
    margin-top: 10px;
}
</style>
